import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#050505] pt-16 pb-8 relative border-t border-germany-platinum/10" data-id="element-38">
      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-germany-black via-germany-platinum to-germany-gold" data-id="element-39"></div>
      <div className="container mx-auto px-6 md:px-12" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-41">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-42">
            <a href="https://shop.qtap.me" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 mb-6" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/dHFF6t2sCE9DhuCAgyYxJp/ChatGPT_Image_Mar_30,_2026,_07_19_46_PM.png" alt="Qtap Logo" className="w-12 h-12 object-contain" decoding="async" data-id="element-44" />
              <span className="font-oswald font-bold text-2xl tracking-wider uppercase" data-id="element-45">
                Qtap <span className="text-germany-gold" data-id="element-46">by STDI</span>
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-sm" data-id="element-47">
              {t('footer.desc')}
            </p>
            <div className="flex items-center gap-4" data-id="element-48">
              <a href="https://www.instagram.com/qtap.me/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#f09433] hover:via-[#dc2743] hover:to-[#bc1888] hover:text-white transition-colors min-h-[44px] min-w-[44px]" data-id="element-49">
                <Instagram size={18} data-id="element-50" />
              </a>
            </div>
          </div>
          {/* Links Columns */}
          <div data-id="element-51">
            <h4 className="font-oswald uppercase font-bold text-white mb-6 tracking-widest" data-id="element-52">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-53">
              <li data-id="element-54">
                <a href="https://www.espn.com/soccer/team/fixtures/_/id/481/ger" target="_blank" rel="noopener noreferrer" className="hover:text-germany-gold transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-55">
                  ESPN Schedule <ExternalLink size={12} data-id="element-56" />
                </a>
              </li>
              <li data-id="element-57">
                <a href="https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/canadamexicousa2026/teams/germany" target="_blank" rel="noopener noreferrer" className="hover:text-germany-gold transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-58">
                  FIFA Official <ExternalLink size={12} data-id="element-59" />
                </a>
              </li>
              <li data-id="element-60">
                <a href="https://www.flashscore.com/team/germany/xS2kU1D1/" target="_blank" rel="noopener noreferrer" className="hover:text-germany-gold transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-61">
                  FlashScore <ExternalLink size={12} data-id="element-62" />
                </a>
              </li>
              <li data-id="element-63">
                <a href="https://www.dfb.de" target="_blank" rel="noopener noreferrer" className="hover:text-germany-gold transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-64">
                  DFB Official <ExternalLink size={12} data-id="element-65" />
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-66">
            <h4 className="font-oswald uppercase font-bold text-white mb-6 tracking-widest" data-id="element-67">
              {t('footer.team')}
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-68">
              <li data-id="element-69">
                <a href="#team" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-70">
                  {t('footer.firstTeam')}
                </a>
              </li>
              <li data-id="element-71">
                <a href="#matches" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-72">
                  {t('footer.matches')}
                </a>
              </li>
              <li data-id="element-73">
                <a href="#matches" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-74">
                  {t('footer.standings')}
                </a>
              </li>
              <li data-id="element-75">
                <a href="#deals" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-76">
                  {t('footer.travelDeals')}
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-77">
            <h4 className="font-oswald uppercase font-bold text-white mb-6 tracking-widest" data-id="element-78">
              {t('footer.support')}
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-81">
                  {t('footer.contactUs')}
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-83">
                  {t('footer.faq')}
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-85">
                  {t('footer.privacy')}
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-germany-gold transition-colors min-h-[44px] flex items-center" data-id="element-87">
                  {t('footer.terms')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500" data-id="element-88">
          <p data-id="element-89">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
          <div className="flex gap-6" data-id="element-90">
            <a href="#" className="hover:text-white transition-colors min-h-[44px] flex items-center" data-id="element-91">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors min-h-[44px] flex items-center" data-id="element-92">
              {t('footer.terms')}
            </a>
            <a href="#" className="hover:text-white transition-colors min-h-[44px] flex items-center" data-id="element-93">
              {t('footer.cookies')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}